<template>
  <el-dialog class="rc-dialog" :title="curdTitle" :visible.sync="CUFlag" v-if="CUFlag" @close="closeDialog"
    :close-on-click-modal="false" width="50%">
    <el-form ref="curdForm" size="small" :rules="rules" :model="curdForm" label-position="right" label-width="100px">
      <el-form-item label="适用组织：" prop="deptName">
        <popup-tree-input :data="deptTreeList" :props="props" :disabled="isEdit" :prop="curdForm.deptName"
          :currentChangeHandle="getMenuID" :loadNode="loadNode" placeholder="请选择适用组织" style="width: 50%;"></popup-tree-input>
      </el-form-item>
      <el-form-item label="生效年份：" prop="effectYear">
        <el-date-picker :default-value="timeDefaultShow" v-model="curdForm.effectYear" type="year" placeholder="选择年"
          :picker-options="pickerOptions" style="width: 50%;" value-format="yyyy" @change="yearChange"
          :disabled="isEdit">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="考核方式：" prop="examType">
        <el-radio-group v-model="curdForm.examType" v-removeAriaHidden :disabled="isEdit">
          <el-radio :label="1">干部级别</el-radio>
          <el-radio :label="2">管理主体</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="考核要求：" required>
        <div v-if="currentList && currentList.length > 0">
          <div>（如无考核要求，可设置达标学时为0）</div>
          <div class="require_row" v-for="(item, i) in currentList" :key="i">
            {{ item.typeName }}，达标学时
            <el-input-number v-model="item.examCredit" :min="0" :precision="0"
              @change="onNumberChange($event, item, i)"></el-input-number>
            <el-checkbox class="m-l-12" label="0" v-model="item.isCompulsory" :true-label="1" :false-label="0"
              @change="onCheckChange($event, item, i)">完成平台必修课</el-checkbox>
          </div>
        </div>
        <div v-else>请先选择适用组织</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn title="取消" @click.native="closeFrom('curdForm')"></butn>
      <butn btntype="primary" title="确定" @click="createData"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { topDeptList } from "@/api/dept";
import {
  examRuleSave,
  examRuleUpdate,
  examRuleInfo,
} from "@/api/examRule";
import { getDataMap, getBusinessParamByTypes } from "@/api/sysParam";
import { lazyTree } from "@/api/dept";
import PopupTreeInput from "@/components/PopupTreeInput/index";

export default {
  components: { butn, PopupTreeInput },
  data() {
    return {
      deptTreeList: [],
      pickerOptions: {
        disabledDate(time) {
          let n = new Date();
          let y = n.getFullYear();
          return time.getFullYear() < y;
        },
      },
      timeDefaultShow: "",
      cadreTypeAttr: [],
      leaderTypeList: [],
      curdTitle: "",
      CUFlag: false,
      curdForm: {},
      defaultDetails: [],
      rules: {
        deptName: [
          { required: true, message: "适用组织不能为空", trigger: "change" },
        ],
        examType: [
          { required: true, message: "请选择考核方式", trigger: "change" },
        ],
        effectYear: [
          {
            required: true,
            message: "生效年份不能为空",
            trigger: "blur,change",
          },
        ],
        // examCredit: [{ required: true, message: "达标学时不能为空" }],
      },
      props: {
        //树形
        label: "name",
        isLeaf: function (data, node) {
          return !data.hasChildren
        },
      },
      command: function () { },
      isEdit: true,
    };
  },
  beforeDestroy() {
  },
  computed: {
    currentList() {
      return this.curdForm.examType == 1 ? this.cadreTypeAttr : this.leaderTypeList;
    }
  },
  created() {
    var _this = this;
    _this.timeDefaultShow = Date.now();
  },
  methods: {

    show(item) {

      // item存在为编辑，不存在为新增
      this.isEdit = !!item;
      this.curdTitle = this.isEdit ? "编辑考核规则" : "新增考核规则";

      this.command = this.isEdit ? examRuleUpdate : examRuleSave;
      this.curdForm = {
        deptId: "",
        deptName: "",
        effectYear: "",
        examType: 1,
      };
      this.cadreTypeAttr = [];
      this.leaderTypeList = [];
      if (this.isEdit) {
        examRuleInfo({
          deptId: item.deptId,
          effectYear: item.effectYear,
          examType: item.examType
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.curdForm = res.data;
          this.curdForm.effectYear = res.data.effectYear;
          if (this.curdForm.examType == 1) {
            this.cadreTypeAttr = res.data.details || [];
          } else {
            this.leaderTypeList = res.data.details || [];
          }
          this.defaultDetails = JSON.parse(JSON.stringify(res.data.details || []));
        });
      } else {
        this.initMenuL();
      }
      this.CUFlag = true;
    },

    getTypeList(deptLevelCode) {
      let types = ['USER_LEADER_TYPE', "EXAM_RULE_CADRE_LEVEL"];
      getBusinessParamByTypes({ types, deptLevelCode }).then((res) => {
        if (!res || res.code != 0) return;
        this.leaderTypeList = this.dealArray(res.data["USER_LEADER_TYPE"])
        this.cadreTypeAttr = this.dealArray(res.data["EXAM_RULE_CADRE_LEVEL"])
      });
    },
    initMenuL() {
      lazyTree().then((res) => {
        this.deptTreeList = res.data;
      });
    },
    yearChange(year) {
      if (this.curdForm.deptId) {
      }
    },
    handleSelectChange(val) {
      this.curdForm.cadreTypeList = val;
    },

    createData() {
      // var _this = this;
      this.$refs.curdForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = Object.assign({}, this.curdForm);
          // 深拷贝，不能影响原数据，如果请求失败，编辑时会有问题
          let list = JSON.parse(JSON.stringify(this.currentList));
          if (this.isEdit) {
            delete params.deptName;
            delete params.examTypeStr;
            params.details = list.filter(item => item.isModify);
          } else {
            params.details = list;
          }
          // 删除无关数据
          params.details = params.details.map(item => {
            if (this.isEdit) {
              delete item.isModify;
            }
            delete item.typeName;
            return item;
          });
          if (params.details && params.details.length > 0) {
            this.command(params)
              .then((res) => {
                if (!res || res.code != 0) throw new Error(res.msg);
                this.$message.success(res.msg);
                this.CUFlag = false;
                this.$emit("search", {});
                if (!this.isEdit) {
                  // 新增 二次弹窗
                  this.$alert(`考核规则新增成功，默认为“未启用”状态。请在列表点击“启用”按钮，该规则在启用后第2天正式生效。`, "系统提示", {
                    confirmButtonText: "确定",
                    type: 'warning',
                  })
                }
              })
              .finally(() => { });
          } else {
            this.$message.warning('当前考核要求未变更');
          }
        }
      });
    },
    closeDialog() {
      // 点击取消 数据重置
      this.CUFlag = false;
    },
    closeFrom() {
      this.CUFlag = false;
    },

    onNumberChange(value, item, i) {
      if (value === '' || value === null || value === undefined) {
        item.examCredit = '0';
      }
      if (this.isEdit) {
        // 判断和请求默认数据是否一致，不一致标记该条数据为修改
        let defaultItem = this.defaultDetails[i];
        item.isModify = defaultItem.examCredit != item.examCredit;
      }
    },

    onCheckChange(value, item, i) {
      if (this.isEdit) {
        // 判断和请求默认数据是否一致，不一致标记该条数据为修改
        let defaultItem = this.defaultDetails[i];
        item.isModify = defaultItem.isCompulsory != item.isCompulsory;
      }
    },

    dealArray(list) {
      if (list && list.length > 0) {
        let newList = list.map(item => {
          return {
            typeName: item.paramValue,
            type: item.paramKey,
            examCredit: 60,
            isCompulsory: 0,
          }
        })
        return newList;
      }
      return [];

    },

    loadNode(node, resolve) {
      // console.log(node);
      if (node.level === 0) {
        return resolve(this.deptTreeList);
      }
      if (node.level >= 1) return this.getChildNode(node, resolve);
    },
    getChildNode(node, resolve) {
      setTimeout(() => {
        lazyTree({
          parentId: node.data.id || "",
        }).then((res) => {
          resolve(res.data);
        });
      }, 300);
    },
    getMenuID(data) {
      if (data.id != this.curdForm.deptId) { //重复点击同一个节点
        console.log('-----11111----', data);
        if (data.deptLevelCode === '001') { //点击了顶级节点
          this.$message.warning('适用组织无法选择顶级节点');
        } else {
          this.curdForm.deptId = data.id;
          this.curdForm.deptName = data.name;
          this.getTypeList(data.deptLevelCode)
        }
      }
    },
  },
  mounted() {
    
  },
};
</script>

<style scoped lang="scss">
.select-tree {
  width: 100%;
}

.ruleTable {
  margin-top: 20px;
}

.m-l-12 {
  margin-left: 12px;
}

.require_row {
  padding: 12px 0;
}
</style>
